import React, { useEffect, useRef } from 'react'

import Select from 'react-select'
import CreatableSelect from 'react-select/creatable'
import selectedItem from './select-util/selectedItem'
import fetchOptions from './select-util/fetchOptions'
import returnValue from './select-util/returnValue'
import style from './select-util/style'
import checkUrl from './select-util/checkUrls'
//import {addNewView, addNewAction} from "./select-util/addNew";
import debounce from './select-util/debounce'
import sizeType from '../util/sizeStyle'

const SelectBaseComponent = ({ item, value, validationMessage, handleChange, bind, formData, valid, force }) => {
  const SelectComponent = item?.addNew ? CreatableSelect : Select

  const [loadedOptions, setLoadedOptions] = React.useState([])
  const [innerValue, setInnerValue] = React.useState(null)
  const [loading, setLoading] = React.useState(false)
  const [loaded, setLoaded] = React.useState(false)
  const [isDisabled, setIsDisabled] = React.useState(false)
  const [innerFormData, setInnerFormData] = React.useState(formData)
  const [initial, setInitial] = React.useState(false)
  const [forceToLoad, setForceToLoad] = React.useState(force)

  const [lastRequest, setLastRequest] = React.useState(0)

  const selectRef = useRef(null)

  const loadOptions = debounce((inputValue) => {
    setInitial(true)
    if (item.api && (!loaded || inputValue)) {
      setLoading(true)
      fetchOptions(item.api, inputValue, value, item.defaultValue, item?.list, formData).then((data) => {
        setLoading(false)
        setLoaded(true)
        setLoadedOptions(data)
      })
    } else if (item.list && !item.api) {
      setLoadedOptions(item.list)
    } else if (item.staticApi && !loaded) {
        fetchOptions(item.staticApi).then((data) => {
            setLoading(false)
            setLoaded(true)
            //console.log("staticApi", data)
            setLoadedOptions(data)
        })
    }
  }, 500)
  useEffect(() => {
    if (forceToLoad !== force) {
      setForceToLoad(force)
      loadOptions()
      setLoaded(false)
    }
  }, [force])

  const selectOption = () => {
    const selected = selectedItem(value, loadedOptions)
    if (bind) bind(selected, item.name)
    return selected
  }

  useEffect(() => {
    setInnerValue(selectOption())

    /*if (value !== "" && value !== null && loadedOptions.length === 0) {
            loadOptions()
        }*/
    const check = checkUrl(item.api, formData, innerFormData, value)
    if (check.reset) {
      setLoaded(false)
    }
    setIsDisabled(check.disable)
    if (value === '') {
      selectRef.current.setValue(null)
      setLoadedOptions([])
    }
    if (loadedOptions.length === 0 && /*!initial &&*/ !item?.disablePreload) {
      loadOptions()
      setLoaded(false)
    }
    if (loadedOptions?.find((item) => item?.value === value)?.length !== 1) {
      loadOptions()
      setLoaded(false)
    }
  }, [value, loadedOptions])

  useEffect(() => {
    let listReset = false
    if (item?.list && item.parent) {
      setLoadedOptions(item.list)
    }
    const check = checkUrl(item.api, formData, innerFormData, value)
    if (check.reset || listReset) {
      setLoaded(false)
    }
    setInnerFormData(formData)
    setIsDisabled(check.disable)

    if (check.reset || listReset) {
      setLoadedOptions([])
      setInnerValue(null)
      handleChange(null, item.name, null)
    }
  }, [formData])

  return (
    <div
      className={`
            ${item.innerClassName || ''} 
            dynamicForm
            ${!Array.isArray(value) ? sizeType[item.size] : ''} !px-0
        `}
    >
      <style>
        {`
                    .dynamicForm .css-1f43avz-a11yText-A11yText,
                    .css-b62m3t-container {
                        width: 100%;
                    }
                    .dynamicForm .css-1y6o3d0-menu {width:100%}
                    .dynamicForm .css-chz8pb-Control:hover {
                        border-color: black;
                    }
                    .dynamicForm .css-chz8pb-Control {
                    cursor: text;
                `}
      </style>
      {/*{loadedOptions.length < 1 ?
                <>Loading..</>
                :*/}
      <SelectComponent
        ref={selectRef}
        menuPortalTarget={typeof document !== 'undefined' ? document.querySelector('body') : null}
        //loadOptions={loadOptions}
        onInputChange={(changeValue) => {
          //if (changeValue !== value && ) {
          loadOptions(changeValue)
          //}
        }}
        /*menuIsOpen={true}*/
        isLoading={loading}
        options={loadedOptions}
        //defaultOptions
        value={innerValue}
        //formatCreateLabel={addNewView}
        //onCreateOption={(newOption) => {addNewAction(newOption, item, formData, loadOptions)}}
        defaultValue={null}
        onChange={(newData) => {
          setInnerValue(newData)
          handleChange(returnValue(newData), item.name, newData)
        }}
        className={`h-full !min-w-full block ${item.innerClassName2 || ''} !bg-transparent`}
        isClearable={false}
        isDisabled={
          isDisabled ||
          (item?.disabled && typeof item?.disabled === 'function' ? item?.disabled(formData) : item?.disabled)
        }
        placeholder={item.placeholder}
        onMenuOpen={() => {
          //if (loadedOptions.length === 0 && !item?.disablePreload) loadOptions()
          if (loadedOptions.length === 0) loadOptions()
        }}
        styles={style({
          validation: validationMessage,
          style: item.style || {},
          item: item,
        })}
        components={{
          //Option: CustomOption,
          IndicatorSeparator: null,
        }}
        {...item.features}
      />
    </div>
  )
}

const CustomOption = ({ label, data, isSelected, innerRef, innerProps }) => (
  <div
    ref={innerRef}
    {...innerProps}
    className={`
            transition-all h-[40px] pr-[17px] pl-[12px]  items-center flex cursor-pointer flex-row gap-[11px] rounded-sm
            text-text-md
            ${isSelected ? 'bg-primary-400  hover:bg-primary-400 cursor-default' : 'hover:bg-primary-100'}
            
        `}
  >
    <span
      className={`
                ${isSelected ? '' : ''}
            `}
    >
      {label}
    </span>
  </div>
)

export default SelectBaseComponent
